import React from "react";
import { useJson } from "../../shared/utils/json";
import { PageProvider } from "../../shared/contexts/page";
import { CustomerProvider } from "../../shared/contexts/customer";
import { PaymentsProvider } from "../../shared/contexts/payments";
import { TitledPaymentPanel } from "../../shared/components/payments";
import {createRoot} from "react-dom/client";
import {getAndStripAttribute} from "../../shared/utils/dom-container-util";

/* NOTE: This is the template used in the order-review panel */

const domContainerId = '#orderReview-payment-panel';

const OrderReviewPaymentsContainer = (props) => {
    const { parseJson } = useJson();
    const model = parseJson(props.model);
    const customerId = model.customerId || model.uid;
    const paymentInfo = model.paymentInfoData;
    const markets = props.markets;
    const cartPaymentId = model.cartPaymentId;
    const activePaymentMethods = model.activePaymentMethods || 'card';
    const runEnv = model.digitalWalletRunEnvironment;
    const applePayAuth = model.forceApplePayAuth;

    return (
        <PageProvider>
            <CustomerProvider uid={model.uid} customerId={customerId} language={model.language}>
                <PaymentsProvider context='modal' activePaymentMethods={activePaymentMethods} cartPaymentId={cartPaymentId} cartMarketType={model.marketOTGOrNFR} isOrderConfirmationPage={model.isOrderConfirmationPage} ccNonce={model.ccNonce}>
                    <TitledPaymentPanel markets={markets} paymentInfo={paymentInfo} digitalWalletEnv={runEnv} googlePayMerchantId={model.googlePayMerchantId} recaptchaKey={model.recaptchaKey} cartShippingAddress={model.cartShippingAddress} applePayAuth={applePayAuth} isOrderConfirmationPage={model.isOrderConfirmationPage}/>
                </PaymentsProvider>
            </CustomerProvider>
        </PageProvider>
    );
};

const domContainer = document.querySelector(domContainerId);
if (domContainer) {
  const markets = getAndStripAttribute("data-markets", domContainer);
  const model = getAndStripAttribute("data-model", domContainer);
  const root = createRoot(domContainer);
  root.render(<OrderReviewPaymentsContainer markets={markets} model={model}/>);
}
